module.exports = __webpack_public_path__ + "static/media/185.dd21156a.jpg";